<template>
  <v-app>
  <v-container>
    <v-row
      justify="center"
      no-gutters
    >
    <h2 
    class="projTitle"
    data-aos="fade-up"
    data-aos-duration="1500"
    >{{title}}</h2>

      <v-col lg="10" md="10" sm="10" class="main-section"
      data-aos="fade-right"
        data-aos-duration="1500">          
          <v-carousel 
        :cycle="true"
        :interval=6000
        class="mx-auto"
        >
        <v-carousel-item
          v-for="(image,i) in images"
          :key="i"
          :src="image.src"
        ></v-carousel-item>
      </v-carousel>      
        <p class="work-desc">
        This project was developed to replace an old VB.Net web forms system. It was started from scratch using MVC4 and Enitiy Framework 5 and leveraged its existing SQL Server database.
      </p>
      <p class="work-desc">
        The challenge was to convert the complex, data driven customer journey from multiple web forms into one UI view, separating sections into a jQuery UI accordion control. The journey through the accordion is implemented with jQuery to ensure the correct path is taken by the user, giving access to components at the right time while being backed up with server side business logic.
      </p>
      <p class="work-desc">
        The website uses Bootstrap components such as Model dialogs, mostly managed with jQuery. AJAX is also heavily used to set out the users' state and progress the journey. Razor partial views are rendered to the main view along with a dynamically generated question flow, shaped by the answers as they are given by the user.
      </p>

      <v-btn class="visit" color="primary" disabled>Visit (internal system)</v-btn>
        
      </v-col>
      <v-col lg="2" md="2" sm="2" cols="auto"
      data-aos="fade-left"
        data-aos-duration="1500">
        
<v-card
          v-for="tech in technologies" :key="tech.name"
        class="tech"
        >
          <v-card-text >
            <div>{{ tech.name }}</div>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>
  </v-container>
  </v-app>
</template>

<script>
  export default {
    name: 'DNAProject',
    data () {
      return {
        images: [
          {
            src: require('../assets/projects/dna1_600.jpg'),
          },
          {
            src: require('../assets/projects/dna2_600.jpg'),
          },
          {
            src: require('../assets/projects/dna3_600.jpg'),
          },
          {
            src: require('../assets/projects/dna4_600.jpg'),
          },
        ],
        technologies: [
        { name: "MVC 4" },
        { name: "C#" },
        { name: "EF 5" },
        { name: "LINQ" },
        { name: "SQL Server" },
        { name: "jQuery" },
        { name: "AJAX" },
        { name: "CSS" },
        { name: "Bootstrap" },
        { name: "jQuery UI" }
    ],
    title: "Demands Needs Advisor (Automotive Insurance)"
      }
    },
  }
</script>
<style scoped>
.container{
  width: 100%;
  margin-bottom: 20px;
}
.text--secondary{
      text-align: left;      
}
.main-section{
  margin-bottom: 15px;
}
.text--desc{margin-bottom: 10px;}
.right{margin-left: 20px;}
.tech{
  margin-bottom: 20px;
  border-radius: 0px 50px 50px 0px!important;
  background-color: #3782d2!important;
  color: #fff!important;
}
.v-card__text{
  color: #fff!important;
  padding: 5px;
  }
.v-window-item{max-width: 100%;}
.work-desc{
  font-size: 1em;
  text-align: left;
}
h2{
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
}
  @media only screen and (max-width: 600px) {
  .tech{
  border-radius: 50px 50px 50px 50px!important;
  width: max-content;
  display: inline-block;
  margin: 5px;
  padding: 5px;
  }
  .columns{
    margin-top: 20px;
  }
}  
.visit{
    width: 100%;
  }
  .projTitle{
    margin-left: auto;
    margin-right: auto;
  }
  .v-application{
  margin-top: 0!important;
  }
  .v-application{
  margin-top: 0!important;
  }
  .row{
    border: solid 5px rgba(55,130,210, 0.2);
    border-radius: 25px;
    padding: 30px;
  }
</style>

